/**
 * Lädt das Lexikon und stellt Suchdienste bereit
 * @class service_v3sLexikonService
 * @memberOf v3sWbtPlayerApp:tools:search
 */
angular.module('v3sWbtPlayerApp').factory('v3sLexikonService', ["$q", "v3sLoaderService", "v3sContentPath", function ($q, v3sLoaderService, v3sContentPath) {
    var loading = null;
    var lexikon = null;

    /**
     * Lädt das Lexikon
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sLexikonService
     * @return ein Promise, das aufgelöst wird, wenn die Seite fertig geladen ist
     */
    function init() {
        if (!loading) {
            // Lade Volltextindex
            loading = v3sLoaderService('lexikon.js', v3sContentPath).then(function (lexikonData) {
                lexikon = lexikonData;
            });
        }

        return loading;
    }

    /**
     * Gibt die Liste der Lexikonbegriffe zurück.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sLexikonService
     * @return ein Promise, das mit der Liste der Begriffe aufgelöst wird
     */
    function getLexikon() {
        var deferred = $q.defer();

        init().then(function () {
            deferred.resolve(lexikon.entries);
        });

        return deferred.promise;
    }

    return {
        init: init,
        getLexikon: getLexikon
    }
}]);